import React, { useState } from "react";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import { Link, Redirect, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import { red } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import LaunchIcon from '@material-ui/icons/Launch';
import CommentIcon from '@material-ui/icons/Comment';
import Grid from '@material-ui/core/Grid';

import { setSelectedComponentObject } from "../../redux/actions/appActions";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

function KnowYourRightsCard(props) {
  const classes = useStyles();
  let history = useHistory();
  let menuItem = props.KnowYourRightsObj.contentList[0];
  let likeCount = props.KnowYourRightsObj.totalLikes ? props.KnowYourRightsObj.totalLikes : 0;
  let commentsCount = props.KnowYourRightsObj.totalComments ? props.KnowYourRightsObj.totalComments : 0;
  const { t } = props;

  function handleClick() {
    if (props.KnowYourRightsObj.hasChild) {
      if (props.KnowYourRightsObj.contentId == 97) {
        props.setSelectedComponentObject({ id: props.KnowYourRightsObj.contentId });
        history.push({
          pathname: "/layout/kyrchild",
          state: { id: props.KnowYourRightsObj.contentId },
        });
      } else {
        history.push({
          pathname: "/layout/getknowyourrightsdetail",
          state: props.KnowYourRightsObj,
        });
      }
    } else {
      history.push({
        pathname: "/layout/getknowyourrightsdetail",
        state: props.KnowYourRightsObj,
      });
    }

  }

  function getHttpsUrl(iconurl) {
    var spliurtl = iconurl.split("://")
    let myUrl = spliurtl.length > 1 ? "https://" + spliurtl[1] : "https://" + spliurtl[0];
    return myUrl;
  }



  if (!menuItem) {
    return <>

      <Grid item xs={12} className="" onClick={handleClick}>
        <div className="informationcardholder">
          <p className="text-left getknwtitle">{props.KnowYourRightsObj && props.KnowYourRightsObj.contentName}</p>
          <p className="zero"></p>
          <p className="getknwsubtitle text-left">{props.KnowYourRightsObj.shortDesc}</p>
          <Grid container spacing={0} className="gridcontainer">
            <Grid item xs={6} className="">
              <p className="getknowupdatedate"></p>
            </Grid>
            <Grid item xs={6} className="getknowiconcontainer">
              <Link className="anchorLink" onClick={handleClick}>
                <IconButton aria-label="read more">
                  <LaunchIcon />
                </IconButton>
              </Link>
              <IconButton aria-label="add to favorites">
                <FavoriteIcon />
                <span className="likecountholder">{likeCount}</span>
              </IconButton>
              <IconButton aria-label="read more">
                <CommentIcon />
                <span className="likecountholder">{commentsCount}</span>
              </IconButton>
            </Grid>
          </Grid>
        </div>
      </Grid>

      {/* <Card className="infocard">
        <CardHeader
          avatar={<Avatar aria-label="recipe" className={classes.avatar}>{props.KnowYourRightsObj && props.KnowYourRightsObj.contentName.charAt(0)}</Avatar>}
          title={props.KnowYourRightsObj && props.KnowYourRightsObj.contentName}
        />
        <CardContent>
          <Grid container spacing={3} className="gridcontainer">
            <Grid item xs={4} className="text-center">
              <Avatar
                alt={props.KnowYourRightsObj & props.KnowYourRightsObj.contentName}
              />
            </Grid>
            <Grid item xs={8} className="text-center">
              <Typography variant="body2" color="textSecondary" component="p" className="text-left">
                {props.KnowYourRightsObj.shortDesc}
              </Typography>
            </Grid>
          </Grid>


        </CardContent>
        <CardActions disableSpacing>
          <Link
            className="anchorLink"
            onClick={handleClick}
          >
            <IconButton aria-label="read more">
              <LaunchIcon />
            </IconButton>
          </Link>
          <IconButton aria-label="add to favorites">
            <FavoriteIcon />
          </IconButton>
          <IconButton aria-label="bookmark">
            <BookmarkIcon />
          </IconButton>

        </CardActions>

      </Card> */}
    </>;
  }

  return (
    <>

      <Grid item xs={12} className="" onClick={handleClick}>
        <div className="informationcardholder">
          <p className="text-left getknwtitle">{menuItem && menuItem.title}</p>
          <p className="zero"><img className="img-fluid" src={menuItem.logoURL ? getHttpsUrl(menuItem.logoURL) : ""} /></p>
          <p className="getknwsubtitle text-left">{menuItem.shortDesc}</p>
          <Grid container spacing={0} className="gridcontainer">
            <Grid item xs={6} className="">
              <p className="getknowupdatedate">{menuItem.date}</p>
            </Grid>
            <Grid item xs={6} className="getknowiconcontainer">
              <Link className="anchorLink" onClick={handleClick}>
                <IconButton aria-label="read more">
                  <LaunchIcon />
                </IconButton>
              </Link>
              <IconButton aria-label="add to favorites">
                <FavoriteIcon />
                <span className="likecountholder">{likeCount}</span>
              </IconButton>
              <IconButton aria-label="read more">
                <CommentIcon />
                <span className="likecountholder">{commentsCount}</span>
              </IconButton>
            </Grid>
          </Grid>
        </div>
      </Grid>

      {/* <Card className="infocard">
        <CardHeader
          avatar={<Avatar aria-label="recipe" className={classes.avatar}>{menuItem && menuItem.title.charAt(0)}</Avatar>}
          title={menuItem && menuItem.title}
          subheader={menuItem.date}
        />
        <CardContent>
          <Grid container spacing={3} className="gridcontainer">
            <Grid item xs={4} className="text-center">
              <Avatar
                alt={menuItem & menuItem.title ? menuItem.title : ""}
                src={menuItem.logoURL ? menuItem.logoURL : ""}
              />
            </Grid>
            <Grid item xs={8} className="text-center">
              <Typography variant="body2" color="textSecondary" component="p" className="text-left">
                {menuItem.shortDesc}
              </Typography>
            </Grid>
          </Grid>


        </CardContent>
        <CardActions disableSpacing>
          <Link className="anchorLink" onClick={handleClick}>
            <IconButton aria-label="read more">
              <LaunchIcon />
            </IconButton>
          </Link>
          <IconButton aria-label="add to favorites">
            <FavoriteIcon />
          </IconButton>
          <IconButton aria-label="bookmark">
            <BookmarkIcon />
          </IconButton>
        </CardActions>

      </Card> */}
    </>
  );
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};


export default connect(mapStateToProps, { setSelectedComponentObject })(withTranslation()(KnowYourRightsCard));